import React from 'react';
import { useWindowSize } from '../../../hooks';
import { formatProfessionalNameForHeader } from '../../../utils/formatUtils';

/**
 * Componente para exibir o cabeçalho de um recurso (profissional) no calendário
 * Adaptado para ser responsivo em diferentes tamanhos de tela
 * 
 * @param {Object} props - Propriedades do componente
 * @param {Object} props.resource - Dados do recurso
 * @returns {JSX.Element} - Elemento React
 */
const TimelineResourceHeader = ({ resource }) => {
  // Verificar se o recurso tem avatar
  const hasAvatar = resource.avatarUrl && resource.avatarUrl.length > 0;
  // Obter o tamanho da tela
  const { width } = useWindowSize();
  
  // Determinar se estamos em uma tela muito pequena
  const isVerySmallScreen = width < 380;
  // Determinar se estamos em uma tela pequena
  const isSmallScreen = width < 500;
  
  /**
   * Formata o nome do profissional adequadamente de acordo com o tamanho da tela
   */
  const renderTitle = () => {
    if (resource.id === 'any') return 'Qualquer';
    
    // Determinar o tamanho da tela para passar como parâmetro
    let screenSize = 'md';
    if (isVerySmallScreen) {
      screenSize = 'xs';
    } else if (isSmallScreen) {
      screenSize = 'sm';
    }
    
    // Usar a função utilitária para formatação do nome
    return formatProfessionalNameForHeader(resource.title, screenSize);
  };
  
  // Estilo otimizado para economizar espaço
  return (
    <div className="flex flex-col items-center justify-center text-center py-1 px-0">
      {/* Avatar (se disponível) ou círculo colorido */}
      {hasAvatar && !isSmallScreen ? (
        <img 
          src={resource.avatarUrl} 
          alt={resource.title}
          className="w-4 h-4 mb-1 rounded-full object-cover flex-shrink-0"
        />
      ) : (
        <div 
          className="w-3 h-3 mb-1 rounded-full flex-shrink-0" 
          style={{ backgroundColor: resource.color }}
        />
      )}
      
      {/* Nome do profissional */}
      <span 
        className="font-medium text-xs truncate w-full" 
        title={resource.title} // Adicionar tooltip com nome completo para acessibilidade
      >
        {renderTitle()}
      </span>
    </div>
  );
};

export default TimelineResourceHeader; 